import { checkAccess } from "../../../utils/roleFunctions";
import { ACCESS, ACCESS_SECTIONS } from "../../../utils/constants/access";

export const hasWarehouseEditAccess = (acc, warehouseId, warehouses) => {
    if (!acc || !warehouseId || !warehouses) return false;
    const warehouse = warehouses.find(w => w.id === warehouseId);
    if (!warehouse) return false;
    return checkAccess(acc, { key: warehouse.accessName, value: ACCESS.EDIT });
}
export const hasWarehouseViewAccess = (acc, warehouseId, warehouses) => {
    if (!acc || !warehouseId || !warehouses) return false;
    const warehouse = warehouses.find(w => w.id === warehouseId);
    if (!warehouse) return false;
    return checkAccess(acc, { key: warehouse.accessName, value: ACCESS.EDIT });
}